import { message } from '@linktivity/link-ui';
import { auth, agent } from '@link/agent/stores';

const BASE_PATH = import.meta.env.VITE_APP_AGENT_API as string;

// 这些接口的错误由页面自行弹窗说明，不再弹全局 message，避免重复
const SILENT_ERROR_PATHS = [
  '/v1/booking/start-cancel-booking',
  '/v1/booking/final-cancel-booking'
];

export interface ServiceConfigOptions {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Configuration: any;
}

export function createServiceConfig({ Configuration }: ServiceConfigOptions) {
  return new Configuration({
    basePath: BASE_PATH,
    middleware: [
      {
        pre: async (context: { init: RequestInit }) => {
          const requestHeaders: HeadersInit = new Headers({
            'Content-Type': 'application/json'
          });
          requestHeaders.append(
            'Authorization',
            'Bearer ' + (await auth.getRefreshedToken())
          );

          if (auth.isLinkAdmin) {
            if (agent.selectedAgentId) {
              requestHeaders.set('grpc-metadata-ota-id', agent.selectedAgentId);
            }
            if (agent.selectedAgentOrgId) {
              requestHeaders.set(
                'grpc-metadata-group-id',
                agent.selectedAgentOrgId
              );
            }
          } else {
            if (agent.selectedAgentId) {
              requestHeaders.set(
                'grpc-metadata-current-ota-id',
                agent.selectedAgentId
              );
            }
          }
          context.init.headers = requestHeaders;
        },
        post: async (context: { response: Response; url: string }) => {
          if (context.response.status === 401) {
            localStorage.clear();
            location.replace('/login');
          } else if (!context.response.ok) {
            // handle error
            const data = await context.response.json();
            if (SILENT_ERROR_PATHS.some(path => context.url.includes(path))) {
              return data;
            }

            // 当 message 为 "unknown error" 时，循环提取 details 的 reason 分别抛出
            if (data?.message === 'unknown error' && data?.details?.length) {
              data.details.forEach((detail: { reason?: string }) => {
                if (detail.reason) {
                  message.error(detail.reason, 10);
                }
              });
            } else {
              const errorMessage = data?.message || data?.details?.[0]?.reason;
              message.error(errorMessage, 10);
            }

            return data;
          }
        }
      }
    ]
  });
}
